var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Select T&C Template")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=\"fa fa-info-circle\"></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('template')
    },
    attrs: {
      "options": _vm.templatelist,
      "selected-option": _vm.selectedTemplate,
      "name": "template",
      "placeholder": "Select T&C Template"
    },
    on: {
      "select": _vm.selectTemplate
    },
    model: {
      value: (_vm.tctemplate),
      callback: function($$v) {
        _vm.tctemplate = $$v
      },
      expression: "tctemplate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('template')),
      expression: "errors.has('template')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('template')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n            Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n            Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "contracttc",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Billing Terms")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Billing Cycle")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calculator'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    attrs: {
      "clearable": false,
      "multiple": false,
      "name": "Billing Cycle",
      "max-height": 200,
      "options": _vm.billigDataList,
      "placeholder": "Select Billing Cycle",
      "append-to-body": true
    },
    on: {
      "select": _vm.selectBillingCycle
    },
    model: {
      value: (_vm.billingCycle),
      callback: function($$v) {
        _vm.billingCycle = $$v
      },
      expression: "billingCycle"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Billing Cycle')),
      expression: "errors.has('Billing Cycle')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Billing Cycle")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("POD Hard Copy required")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pod),
      expression: "pod"
    }],
    attrs: {
      "type": "radio",
      "name": "pod",
      "id": "yes",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.pod, "1")
    },
    on: {
      "__c": function($event) {
        _vm.pod = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pod),
      expression: "pod"
    }],
    attrs: {
      "type": "radio",
      "name": "pod",
      "id": "no",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.pod, "0")
    },
    on: {
      "__c": function($event) {
        _vm.pod = "0"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "no"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pod')),
      expression: "errors.has('pod')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select POD Hard Copy")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.billingCycle && _vm.billingCycle != 3) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Last Date for Bill Submission")]), _vm._v(" "), (_vm.billingCycle) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Cycle")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Day of the Month(1-31)")])])])]), _vm._v(" "), _c('tbody', [(_vm.billingCycle == 2) ? _c('td', [_vm._v("1"), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.billingCycle == 1) ? _c('td', [_vm._v("1")]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.billingCycle == 2) ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.cycleError))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.billingCycle) ? _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('between:1,31'),
      expression: "'between:1,31'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.date1),
      expression: "date1"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('date1')
    },
    attrs: {
      "id": "date1",
      "name": "date1",
      "type": "number",
      "placeholder": "Enter Date "
    },
    domProps: {
      "value": (_vm.date1)
    },
    on: {
      "change": _vm.changeCycle,
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date1 = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.billingCycle) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('date1')),
      expression: "errors.has('date1')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('date1')))]) : _vm._e(), _c('br'), _c('br'), _vm._v(" "), (_vm.billingCycle == 2) ? _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('between:1,31'),
      expression: "'between:1,31'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.date2),
      expression: "date2"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('date2')
    },
    attrs: {
      "id": "date2",
      "name": "date2",
      "type": "number",
      "placeholder": "Enter Date "
    },
    domProps: {
      "value": (_vm.date2)
    },
    on: {
      "change": _vm.changeCycle,
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date2 = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.billingCycle == 2) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('date2')),
      expression: "errors.has('date2')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('date2')))]) : _vm._e()], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pod == 1) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("POD Hard Copy Charges (INR per POD)"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])]) : _vm._e(), _vm._v(" "), (_vm.pod == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.podCharge),
      expression: "podCharge"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('PodHardCopyCharge')
    },
    attrs: {
      "id": "podCharge",
      "name": "PodHardCopyCharge",
      "type": "number",
      "min": "1",
      "placeholder": "Charges"
    },
    domProps: {
      "value": (_vm.podCharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.podCharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PodHardCopyCharge')),
      expression: "errors.has('PodHardCopyCharge')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("POD Hard Copy Charges is required")])], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "contracttc",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Credit and Payment Terms")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Credit Period (Days) "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _c('br'), _vm._v("(From Date of Submission of Bill)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1', 'required'),
      expression: "'min_value:1', 'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.creditPeriod),
      expression: "creditPeriod"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('CreditPeriodDays')
    },
    attrs: {
      "id": "creditPeriod",
      "name": "CreditPeriodDays",
      "type": "number",
      "min": "1",
      "placeholder": "Days"
    },
    domProps: {
      "value": (_vm.creditPeriod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditPeriod = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CreditPeriodDays')),
      expression: "errors.has('CreditPeriodDays')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Credit Period is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Credit Limit (INR)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.creditLimit),
      expression: "creditLimit"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('CreditLimit')
    },
    attrs: {
      "id": "creditLimit",
      "name": "CreditLimit",
      "type": "number",
      "min": "1",
      "placeholder": " Limit"
    },
    domProps: {
      "value": (_vm.creditLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditLimit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CreditLimit')),
      expression: "errors.has('CreditLimit')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('CreditLimit')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Advance Payment %")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-percent'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.isftlservicetaken == true? 'required|min_value:1' : 'min_value:1'))),
      expression: "`${isftlservicetaken == true? 'required|min_value:1' : 'min_value:1'}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.advancePayment),
      expression: "advancePayment"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('AdvancePayment')
    },
    attrs: {
      "id": "advancePayment",
      "name": "AdvancePayment",
      "type": "number",
      "min": "1",
      "placeholder": "Payment"
    },
    domProps: {
      "value": (_vm.advancePayment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.advancePayment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AdvancePayment')),
      expression: "errors.has('AdvancePayment')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('AdvancePayment')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Credit Limit Alert %")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-percent'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.creditAlert),
      expression: "creditAlert"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('CreditLimitAlert')
    },
    attrs: {
      "id": "creditAlert",
      "name": "CreditLimitAlert",
      "type": "number",
      "min": "1",
      "placeholder": "Alert"
    },
    domProps: {
      "value": (_vm.creditAlert)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditAlert = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CreditLimitAlert')),
      expression: "errors.has('CreditLimitAlert')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('CreditLimitAlert')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("(For FTL Mode Only)")])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-group row checkbox"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Payment Mode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentmode),
      expression: "paymentmode"
    }],
    attrs: {
      "type": "checkbox",
      "id": "Cheque",
      "value": "1",
      "name": "paymentmode"
    },
    domProps: {
      "checked": Array.isArray(_vm.paymentmode) ? _vm._i(_vm.paymentmode, "1") > -1 : (_vm.paymentmode)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.paymentmode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.paymentmode = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.paymentmode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.paymentmode = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "1"
    }
  }, [_vm._v("Cheque")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding": "0px 30px 0px 0px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentmode),
      expression: "paymentmode"
    }],
    attrs: {
      "type": "checkbox",
      "id": "DemandDraft",
      "value": "2",
      "name": "paymentmode"
    },
    domProps: {
      "checked": Array.isArray(_vm.paymentmode) ? _vm._i(_vm.paymentmode, "2") > -1 : (_vm.paymentmode)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.paymentmode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.paymentmode = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.paymentmode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.paymentmode = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "2"
    }
  }, [_vm._v("Demand Draft")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentmode),
      expression: "paymentmode"
    }],
    attrs: {
      "type": "checkbox",
      "id": "RTGS",
      "value": "3",
      "name": "paymentmode"
    },
    domProps: {
      "checked": Array.isArray(_vm.paymentmode) ? _vm._i(_vm.paymentmode, "3") > -1 : (_vm.paymentmode)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.paymentmode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.paymentmode = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.paymentmode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.paymentmode = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "3"
    }
  }, [_vm._v("RTGS")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('paymentmode')),
      expression: "errors.has('paymentmode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Payment Mode")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("In favour of "), _c('b', [_vm._v("Busybees Logistics Solutions Pvt. Ltd")])])]), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "contracttc",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Other Terms and Conditions")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Max Liability")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Max Liability Amount (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1', 'required'),
      expression: "'min_value:1', 'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.liabilityAmount),
      expression: "liabilityAmount"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('MaxLiabilityAmount')
    },
    attrs: {
      "id": "liabilityAmount",
      "name": "MaxLiabilityAmount",
      "type": "number",
      "min": "1",
      "placeholder": "Amount"
    },
    domProps: {
      "value": (_vm.liabilityAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.liabilityAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MaxLiabilityAmount')),
      expression: "errors.has('MaxLiabilityAmount')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Max Liability Amount is required")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("COF to be issued for lost,damaged or pilferage in case liability is more than maximum liability amount")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("COF (Certificate of Fact)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Shipment will be accepted for transportation on the owner's risk basis. The shipper\n                    is required to make his own transit insurance . In the event of any unforeseen circumstances or damage or loss\n                    ,the certificate of fact (COF) will be issued by XpressBees .")])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showbutton) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dataSubmit('Save')
      }
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dataSubmit('SaveTCAndNext')
      }
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]) : _vm._e()])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71e19c7c","hasScoped":true}!./src/modules/shared/components/Template1/t&c/t&c.component.html
// module id = 666
// module chunks = 3